import React from 'react';

const Home = () => {
  return(
    <article id="intro">
      <div id="welcome-banner">
        <p>Welcome to the Remote Learning Embedded Systems Capstone, for Autumn, 2020!</p>
      </div>
      <section>
        <h1>Project Report</h1>
        <p>
          Download a PDF of the project report
          <a href="./data/CSE475Report.pdf" target="_blank" rel="noreferrer">
          <strong> here</strong>
          </a>.
        </p>
      </section>
      <hr />
      <section>
        <h1>Course Description</h1>
        <p>
          In this capstone, we are exploring the Internet of Things and cloud computing using
          an Arm Cortex M0 processor with a WiFI network interface and a kit of environmental
          sensors.
        </p>
      </section>
      <hr />
      <section>
        <h1>Course Organization</h1>
        <p>
          Initial meetings will be Tuesdays and Thursday, 2:30-4:20pm on <strong>Zoom </strong>
          for background on the hardware, to get our project groups organized, and later for
          review of progress as needed.
        </p>
        <p>
          After we get organized, we will meet on Tuesdays, 2:30-4:20 p.m. on
          <strong> Zoom</strong>, and other times as arranged by project teams. We are
          supplying each person an
          <a href="https://www.okiolabs.com/download" target="_blank" rel="noreferrer"> Okiocam S document camera </a>
          that works on Zoom to show your work and support
          debugging. Download the Quick Start Guide for your computer.
        </p>
        <p>
          Zoom Meeting:
            <a href="https://washington.zoom.us/j/95767362672" target="_blank" rel="noreferrer">
              <strong> Here </strong>
            </a>
          </p>
      </section>
      <hr />
      <section>
        <h1>Important Deadlines</h1>
        <p>
          Final project online demonstration on Tuesday, December 8th, 2:30-4:30 PM, via
          <strong> Zoom</strong>.
        </p>
        <p>
          Project Final Reports are due on
          <a href="https://canvas.uw.edu/courses/1396769" target="_blank" rel="noreferrer"><strong> Canvas </strong></a>
          by 10 pm on December 10th.
        </p>
      </section>
      <p><strong>Refer to
      <a href="https://canvas.uw.edu/courses/1396769" target="_blank" rel="noreferrer"><strong> Canvas </strong></a>
      for more information</strong></p>
    </article>
  )
}

export default Home;
